export enum Workspace {
  nonWorkspace = 'nonWorkspace',
  sbb_eigentumsflaeche = 'sbb_eigentumsflaeche',
  verkaufsobjekte = 'verkaufsobjekte',
  strategieflaechen = 'strategieflaechen',
  sap = 'sap',
  nutzflaecheInfra = 'nutzflaecheInfra',
  areale = 'areale',
  denkmalpflege = 'denkmalpflege',
  gebaeude = 'gebaeude',
}
